import React from 'react'
import BaseScreen from './containers/baseScreen/BaseScreen'
import './styles.css'
import './components/Loader/loader.css'

export const App = () => {
  const [isLoading, setIsLoading] = React.useState(true)

  const handleLoading = () => {
    setIsLoading(false)
  }

  React.useEffect(() => {
    window.addEventListener('load', handleLoading)
    return () => window.removeEventListener('load', handleLoading)
  }, [])

  return !isLoading ? (
    <BaseScreen />
  ) : (
    <div className="loaderBody">
      <div className="loaderContainer">
        <div className="loader"></div>
      </div>
    </div>
  )
}
